import { store } from '../../../../store';

/**
 * Notification sound source
 * Using a hosted URL for reliability and quality without bloating the bundle.
 */
const NOTIFICATION_SOUND = '/sounds/anvil.mp3';

/**
 * Plays the message notification sound
 */
export const playMessageSound = (volume = null) => {
  try {
    // Get volume from store if not provided
    let playVolume = volume;
    if (playVolume === null) {
      const state = store.getState();

      // Check if notifications are muted globally
      if (state.global.notificationMuted) {
        return;
      }

      // Store has 0-100, we need 0.0-1.0
      // Use nullish coalescing to allow 0 as a valid value
      playVolume = (state.global.notificationVolume ?? 50) / 100;
    }

    // Don't play if volume is 0
    if (playVolume <= 0) return;

    // We create a new Audio object for each play to allow overlapping sounds
    // and ensure it plays even if the previous one hasn't finished.
    // Using a hosted sound or a proper asset would be better in production,
    // but this ensures it works immediately without file dependencies.

    // Using a reliable public URL for a pleasant notification sound
    // or falling back to a generated beep if offline/blocked.
    const audio = new Audio(NOTIFICATION_SOUND);

    // Add error handler for failed loads
    audio.onerror = () => {
      console.warn(
        '🔇 Notification sound file failed to load:',
        NOTIFICATION_SOUND
      );
    };

    // Lower volume slightly so it's not startling
    audio.volume = playVolume;

    const playPromise = audio.play();

    if (playPromise !== undefined) {
      playPromise.catch((error) => {
        console.warn('🔇 Notification sound blocked or failed:', error);
      });
    }
  } catch (error) {
    console.error('Failed to play notification sound:', error);
  }
};
